import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import Icon from '../ui/Icon';
import categories from '../../data/categories';

/**
 * Компонент Footer - подвал сайта с навигацией и контактами
 */
const Footer = () => {
    const currentYear = new Date().getFullYear();

    // для робота-поисковика яндекса, чтобы ждал, пока страница загрузится полностью
    useEffect(() => {
        window.YandexRotorSettings = {
            WaiterEnabled: true,
            FailOnTimeout: false,
            NoJsRedirectsToMain: true
        }

        setTimeout(() => {
            window.YandexRotorSettings.IsLoaded = true;
        }, 10000);
    }, []);

    useEffect(() => {
        setInterval(() => {
            if (!document.getElementById('sidebarAds')) {
                let sidebar = document.querySelector('aside');
                if (sidebar) {
                    let adverts = '<div id="sidebarAds"><div class=\'adfinity_block_side300\'></div></div>';
                    sidebar.insertAdjacentHTML("afterbegin", adverts);
                }
            }
            if (!document.getElementById('sidebarAds1')) {
                let sidebar = document.querySelector('aside > div:nth-child(3)');
                if (sidebar) {
                    let adverts = '<div id="sidebarAds1"><div class=\'adfinity_block_side300\'></div><div class=\'adfinity_block_side300\'></div><div class=\'adfinity_block_side300\'></div><div class=\'adfinity_block_side600\'></div></div>';
                    sidebar.insertAdjacentHTML("afterend", adverts);
                }
            }
            /*if (window.location.href === 'https://gensio.ru/tools/finance/education-savings-calculator' && window.innerWidth >= 1440 && !document.getElementById('leftFixAds')) {
                let adverts = '<div id="leftFixAds" style="z-index: 9999; position: absolute; top: 0; right: 0;"><div class=\'adfinity_block_240Х400\'></div><div class=\'adfinity_block_240Х400\'></div></div>';
                document.getElementsByTagName('body')[0].insertAdjacentHTML("afterbegin", adverts);
            }*/
        }, 1000);
    }, []);

    return (
        <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div className="md:col-span-2">
                        <div className="flex items-center mb-4">
                            <div className="p-2 rounded-lg mr-2">
                                <img src="/logo192.png" alt="Logo" className="h-8 w-8"/>
                            </div>
                            <span className="font-bold text-xl text-indigo-600 dark:text-indigo-400">
                Gensio
              </span>
                        </div>
                        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
                            Бесплатная платформа для всех ваших вычислений. Мы создали более 300 удобных инструментов
                            для решения повседневных задач.
                        </p>
                    </div>

                    <div>
                        <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-400 tracking-wider uppercase mb-4">
                            Инструменты
                        </h3>
                        <ul className="space-y-3">
                            {categories.slice(1, 5).map(category => (
                                <li key={category.id}>
                                    <Link
                                        to={`/category/${category.slug}`}
                                        className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                                    >
                                        {category.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-400 tracking-wider uppercase mb-4">
                            О нас
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <Link
                                    to="/about"
                                    className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                                >
                                    О проекте
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/faq"
                                    className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                                >
                                    FAQ
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contacts"
                                    className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                                >
                                    Контакты
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div
                    className="border-t border-gray-200 dark:border-gray-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-500 dark:text-gray-400 text-sm order-2 md:order-1 mt-4 md:mt-0">
                        © {currentYear} Gensio. Все права защищены.
                    </p>
                    <div className="flex space-x-6 order-1 md:order-2">
                        <Link to="/privacy"
                              className="text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 text-sm">
                            Политика конфиденциальности
                        </Link>
                        <Link to="/terms"
                              className="text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 text-sm">
                            Условия использования
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;